import { isMobileOnly } from 'react-device-detect';
import { HallMaintenanceTask } from '../../domain/HallMaintenanceTask';
import HallMaintenanceTasksDesktopTable from './HallMaintenanceTasksDesktopTable';
import HallMaintenanceTasksMobileList from './HallMaintenanceTasksMobileList';

interface Props {
    tasks: HallMaintenanceTask[];
    canManage: boolean;
    onView: (task: HallMaintenanceTask) => void;
    onEdit: (task: HallMaintenanceTask) => void;
    onDelete: (task: HallMaintenanceTask) => void;
    onAssignments: (task: HallMaintenanceTask) => void;
}

const HallMaintenanceTasksTable = (props: Props) => {
    if (isMobileOnly) {
        return (
            <HallMaintenanceTasksMobileList
                tasks={props.tasks}
                canManage={props.canManage}
                onView={props.onView}
                onEdit={props.onEdit}
                onDelete={props.onDelete}
                onAssignments={props.onAssignments}
            />
        );
    }

    return (
        <HallMaintenanceTasksDesktopTable
            tasks={props.tasks}
            canManage={props.canManage}
            onView={props.onView}
            onEdit={props.onEdit}
            onDelete={props.onDelete}
            onAssignments={props.onAssignments}
        />
    );
};

export default HallMaintenanceTasksTable;
